<div class="container my-5 text-center">
    <p>{{'pr.ReservationError'|translate}}</p>
    <p-button (click)="goToProfile()">{{'pr.tryAgain'|translate}}</p-button>
</div>
